import "@fontsource/roboto/300.css";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light"
  },

  components: {
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.severity === "info" && {
            backgroundColor: "black"
          })
        })
      }
    }
  }
});

export default theme;
